export default "__VITE_ASSET__642b2dde__"